'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Utils


var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ElementDropTarget = require('../../element/dnd/ElementDropTarget');

var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);

var _fileValidator = require('../../utils/services/file/fileValidator');

var _dragAndDropUtils = require('../../utils/dnd/dragAndDropUtils');

var _canvasUtil = require('./canvasUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// When dropping file onto the canvas, offset the drop position by 60 pixels, just to make it feel a little nicer
var FILE_DROP_OFFSET = -60;
var FILE_DROP_EACH_OFFSET = 30;

var NATIVE_TYPES = [_reactDndHtml5Backend.NativeTypes.FILE, _reactDndHtml5Backend.NativeTypes.URL, _reactDndHtml5Backend.NativeTypes.TEXT];

var getNativeDropLocation = function getNativeDropLocation(props, monitor, component) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var gridSize = props.gridSize,
        currentBoardId = props.currentBoardId;


    var domComponent = _reactDom2.default.findDOMNode(component);
    var dropPosition = {
        x: monitor.getClientOffset().x + FILE_DROP_OFFSET + FILE_DROP_EACH_OFFSET * i,
        y: monitor.getClientOffset().y + FILE_DROP_OFFSET + FILE_DROP_EACH_OFFSET * i
    };

    return (0, _canvasUtil.getCanvasLocation)(domComponent, dropPosition, gridSize, currentBoardId);
};

// text dropping functionality
var handleTextDrop = function handleTextDrop(props, monitor, component) {
    var createShortcutCard = props.createShortcutCard,
        isEditable = props.isEditable,
        currentBoardId = props.currentBoardId;

    var _monitor$getItem = monitor.getItem(),
        text = _monitor$getItem.text;

    if (!isEditable) return;

    var _getNativeDropLocatio = getNativeDropLocation(props, monitor, component),
        location = _getNativeDropLocatio.location;

    createShortcutCard({ location: location, text: text, currentBoardId: currentBoardId });
};

// file dropping functionality
var handleFileDrop = function handleFileDrop(props, monitor, component) {
    var createShortcutImage = props.createShortcutImage,
        isEditable = props.isEditable,
        currentBoardId = props.currentBoardId,
        dispatchErrorUploadingElementAttachment = props.dispatchErrorUploadingElementAttachment;

    var _monitor$getItem2 = monitor.getItem(),
        files = _monitor$getItem2.files;

    if (!isEditable) return;

    files.forEach(function (file, i) {
        // TODO Should do some type detection here
        var validationErrors = (0, _fileValidator.validateImageFile)(file);

        var _getNativeDropLocatio2 = getNativeDropLocation(props, monitor, component, i),
            location = _getNativeDropLocatio2.location;

        // TODO This is very similar to the ImageContainer. Possibly share the code?


        if (validationErrors) {
            // Create the empty element to show the error in
            var elementId = createShortcutImage({
                location: location,
                currentBoardId: currentBoardId
            });

            dispatchErrorUploadingElementAttachment({
                id: elementId,
                error: validationErrors
            });
            return;
        }

        createShortcutImage({ location: location, file: file, currentBoardId: currentBoardId });
    });
};

// url dropping functionality
var handleUrlDrop = function handleUrlDrop(props, monitor, component) {
    var createShortcutLink = props.createShortcutLink,
        isEditable = props.isEditable,
        currentBoardId = props.currentBoardId,
        deselectAll = props.deselectAll;

    var _monitor$getItem3 = monitor.getItem(),
        urls = _monitor$getItem3.urls;

    if (!isEditable) return;

    urls.forEach(function (url, i) {
        var _getNativeDropLocatio3 = getNativeDropLocation(props, monitor, component, i),
            location = _getNativeDropLocatio3.location;

        createShortcutLink({ location: location, url: url, currentBoardId: currentBoardId });
        deselectAll();
    });
};

// Drop Target functionality.
var dropLocationFn = function dropLocationFn(props, monitor, component) {
    if ((0, _dragAndDropUtils.dropTargetAlreadyHandled)(monitor, component)) return;

    // Don't handle the drop if it's already been handled by something else on the canvas.
    if (monitor.didDrop()) return;

    if (monitor.getItemType() === _reactDndHtml5Backend.NativeTypes.TEXT) return handleTextDrop(props, monitor, component);
    if (monitor.getItemType() === _reactDndHtml5Backend.NativeTypes.FILE) return handleFileDrop(props, monitor, component);
    if (monitor.getItemType() === _reactDndHtml5Backend.NativeTypes.URL) return handleUrlDrop(props, monitor, component);

    var gridSize = props.gridSize,
        currentBoardId = props.currentBoardId;

    var domComponent = _reactDom2.default.findDOMNode(component);

    var item = monitor.getItem();
    var dropPosition = (0, _dragAndDropUtils.getElementDropPosition)({
        item: item,
        sourceClientOffset: monitor.getSourceClientOffset(),
        clientOffset: monitor.getClientOffset(),
        gridSize: gridSize
    });

    var canvasLocation = (0, _canvasUtil.getCanvasLocation)(domComponent, dropPosition, gridSize, currentBoardId);
    return _extends({}, canvasLocation, {
        // The canvas accepts all elements
        acceptedElementIds: item.draggedElementIds
    });
};

var canvasDropCollect = function canvasDropCollect(connector) {
    return {
        connectDropTarget: connector.dropTarget()
    };
};

exports.default = (0, _ElementDropTarget2.default)({ drop: dropLocationFn, acceptDropTypes: NATIVE_TYPES }, null, canvasDropCollect);


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/dnd/canvasDropTargetDecorator.js
// module id = 1692
// module chunks = 0